import React, { useEffect, useRef, useState } from 'react';
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import { ScaleLine } from 'ol/control';
import { defaults as defaultInteractions } from 'ol/interaction';
import useMVTCadastreSelection from '@/hooks/useMVTCadastreSelection';
import useMeasures from '@/hooks/useMeasures';
import useValidatedParcelleSync from '@/hooks/useValidatedParcelleSync';
import { measureDrawArea, measureDrawLength, selectValidatedParcelle } from '@/ol/interactions';
import {
  baseLayers,
  envLayers,
  measureDrawLayer,
  parcelLayer,
  selectedParcelLayer,
  validatedParcelLayer,
} from '@/ol/layers';
import { getParcelStyle } from '@/ol/styles';
import BottomRightCtrl from './BottomRightCtrl';
import ContactFormDialog from './ContactFormDialog';
import DemandeDialog from './DemandeDialog';
import EnvContraintesDialog from './EnvContraintesDialog';
import styles from './OlMap.module.scss';
import ParcelleSelectionCheckDialog from './ParcelleSelectionCheck/ParcelleSelectionCheckDialog';
import SearchLocationDialog from './SearchLocation/SearchLocationDialog';
import LeftToolbar from './Toolbars/Left';
import RightToolbar from './Toolbars/Right';

const CENTER = [259112.154, 5891832.064];
const EXTENT = [-1475747.427, 4489738.693, 1922318.242, 7091328.377];

export default function OlMap() {
  const [map, setMap] = useState(null);

  const mapRef = useRef();

  useEffect(() => {
    const _view = new View({
      extent: EXTENT,
      center: CENTER,
      zoom: 6,
    });

    parcelLayer.setStyle((feature) => getParcelStyle(feature, _view));

    const _map = new Map({
      target: mapRef.current,
      layers: [...baseLayers, ...envLayers, selectedParcelLayer, validatedParcelLayer, measureDrawLayer],
      view: _view,
      controls: [new ScaleLine({ className: 'customScaleLine' })],
      interactions: defaultInteractions({
        altShiftDragRotate: false,
        pinchRotate: false,
        doubleClickZoom: false,
      }).extend([selectValidatedParcelle, measureDrawArea, measureDrawLength]),
    });

    setMap(_map);

    const cleanup = () => _map.setTarget(null);

    return cleanup;
  }, []);

  useMVTCadastreSelection(map);
  useMeasures(map);
  useValidatedParcelleSync();

  return (
    <div className={styles.mapContainer}>
      <div ref={mapRef} className={styles.map}></div>
      {map && (
        <>
          <SearchLocationDialog map={map} />
          <LeftToolbar map={map} />
          <RightToolbar map={map} />
          <BottomRightCtrl />
          <EnvContraintesDialog />
          <ContactFormDialog />
          <ParcelleSelectionCheckDialog />
          <DemandeDialog />
        </>
      )}
    </div>
  );
}
